export function siteMain(){
    let header = document.querySelector('.site-content > header')

    if(!header){
        return;
    }

    let navigation = (document.querySelector('header.site')) ? document.querySelector('header.site').offsetHeight : 0,
        admin_bar = (document.querySelector('#wpadminbar')) ? document.querySelector('#wpadminbar').offsetHeight : 0

    if(!header.classList.contains('archive-header')){
        header.style.marginTop = (navigation - admin_bar - 5) + 'px';
    }
}